import { useMutation } from "react-query";

import { downloadBulkRescheduleCsvTemplate } from "../../../../../api/logistics/bulkReschedule";
import { notification } from "antd";

export const useDownloadCsvTemplate = () => {
  const downloadTemplate = async () => {
    const res = await downloadBulkRescheduleCsvTemplate();
    const blob = new Blob([res.data], { type: "application/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "bulk_reschedule_template.csv");
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  };

  const { mutate: downloadCsvTemplate, isLoading: isDownloadingTemplate } = useMutation(downloadTemplate, {
    onSuccess() {
      notification.success({
        message: "Download Success",
      });
    },
    onError(error) {
      notification.error({
        message: "Download Template Failed",
        description: `${error}`,
      });
    },
  });

  return { downloadCsvTemplate, isDownloadingTemplate };
};
